import { Circle } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '~/utils/cn'
import { AutoRechargeSettings } from '../types'
import { isAutoRechargeLimitReached, isAutoRechargePaymentFailed } from '../utils'

type AutoRechargeStatusProps = {
  settings: AutoRechargeSettings[keyof AutoRechargeSettings]
  className?: string
  textClassName?: string
  prefix?: ReactNode
}

export const AutoRechargeStatus = ({ settings, className, textClassName, prefix }: AutoRechargeStatusProps) => {
  let statusText = 'Disabled'
  let dotColor = 'text-gray-400'

  if (isAutoRechargeLimitReached(settings)) {
    statusText = 'Limit Reached'
    dotColor = 'text-yellow-400'
  } else if (isAutoRechargePaymentFailed(settings)) {
    statusText = 'Error'
    dotColor = 'text-red-500'
  } else if (settings.enabled) {
    statusText = 'Enabled'
    dotColor = 'text-teal-400'
  }

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <Circle className={cn('!size-2 fill-current', dotColor)} />
      <span className={textClassName}>
        {prefix}
        {statusText}
      </span>
    </div>
  )
}
